import http from "@/common/http.service";
const SAVELIST_URL = "contacts/saveList";
const EDIT_URL = "contacts/fetchOneList";
const MAPPING_URL = "contacts/getMappingdata";
const MAPPINGDATA_URL = "contacts/setMappingData";
const SAVE_MAPPINGLIST = "contacts/saveList_mappingContact";
const COPY_PAISTE_MAP = "contacts/getCopyPaisteMaping";
const SAVE_COPYPAISTE = "contacts/saveList_CopyPaistemap";
const SAVE_SINGLE_CONTACT = "contacts/saveList_sinleContact";
const LISTDATA_URL = "contacts/listcounts";
const SUBSCRIBERS_URL = "contacts/subscribers";
const EMAIL_VIEW = "contacts/emailDetails";
const PERFORMANCE_URL = "contacts/performance";
const UPDATESUB_URL = "contacts/updatasubscribers";
const DELETE_URL = "contacts/deleteContact";
const SUBSCRIBER_ANALYTICS = "contacts/listanalytics";
const DEVICE_URL = "contacts/devices";
const DELETECONTACTS_URL = "contacts/deleteextracontacts";
const CHECKQUOTA = "contacts/checkbalance";
const CONV_URL = "contacts/conversions";
const EMAIL_INACTIVE = "contacts/active_inactive";
const DOMAIN_LIST = "contacts/statistics";
const SMTP_LIST = "contacts/domainstatitics";
const SEND_OTP = "contacts/sendotp";
const SAVE_EXPORT_LOG = "contacts/savelog";
const SAVE_CUSTOM_FIELD = "fields/save";
const DELETE_CUSTOM_FIELD = "fields/delete";
const CUSTOM_FIELD_LIST = "fields/list";
const TAG_ACTIONS = "contacts/tagAction";
export default {
  tagActions(params) {
    return http.post(TAG_ACTIONS, params);
  },
  saveList(params) {
    return http.post(SAVELIST_URL, params);
  },
  saveCustomField(params) {
    return http.post(SAVE_CUSTOM_FIELD, params);
  },
  deleteCustomField(id) {
    return http.post(DELETE_CUSTOM_FIELD, { id: id });
  },
  fetchOneList(params) {
    return http.post(EDIT_URL, params);
  },
  mappingData() {
    return http.post(MAPPING_URL);
  },
  setMappingData(params) {
    return http.post(MAPPINGDATA_URL, params);
  },
  saveList_mappingContact(params) {
    return http.post(SAVE_MAPPINGLIST, params);
  },
  getCopyPaisteMaping(params) {
    return http.post(COPY_PAISTE_MAP, params);
  },
  saveList_CopyPaistemap(params) {
    return http.post(SAVE_COPYPAISTE, params);
  },
  saveList_sinleContact(params) {
    return http.post(SAVE_SINGLE_CONTACT, params);
  },
  getListData(params, cb) {
    http.post(LISTDATA_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  getSubscribersFromList(params, cb) {
    http.post(SUBSCRIBERS_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  getSubscriberData(params, cb) {
    http.post(EMAIL_VIEW, params).then(function (response) {
      cb(response.data);
    });
  },
  getuserPerfomance(params, cb) {
    http.post(PERFORMANCE_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  editSubscriber(params) {
    return http.post(EMAIL_VIEW, params);
  },
  updateSubscriber(params) {
    return http.post(UPDATESUB_URL, params);
  },
  deleteContact(params) {
    return http.post(DELETE_URL, params);
  },
  emailInactive(params) {
    return http.post(EMAIL_INACTIVE, params);
  },
  getListAnalytics(params, cb) {
    http.post(SUBSCRIBER_ANALYTICS, params).then(function (response) {
      cb(response.data);
    });
  },
  getDeviceDetails(params, cb) {
    http.post(DEVICE_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  deleteContactWithPlan(params) {
    return http.post(DELETECONTACTS_URL, params);
  },
  checkbalance() {
    return http.post(CHECKQUOTA);
  },
  getConverionCount(params, cb) {
    http.post(CONV_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  domainlistanalytics(params, cb) {
    http.post(DOMAIN_LIST, params).then(function (response) {
      cb(response.data);
    });
  },
  smtpdomainanalytics(params, cb) {
    http.post(SMTP_LIST, params).then(function (response) {
      cb(response.data);
    });
  },
  sendOtp(params) {
    return http.post(SEND_OTP, params);
  },

  getSubscribersExport(params) {
    return http.post(SUBSCRIBERS_URL, params);
  },

  saveExportLog(params, cb) {
    http.post(SAVE_EXPORT_LOG, params).then(function (response) {
      cb(response.data);
    });
  },
  getListCustomFields(params, cb) {
    const promise = http.post(CUSTOM_FIELD_LIST, params);
    return promise.then(function (response) {
      cb(response.data);
      return response.data;
    });
  },
};
